import React from 'react';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import HistoryIcon from '@material-ui/icons/History';
import CardGiftCardIcon from '@material-ui/icons/CardGiftcard';
import HelpIcon from '@material-ui/icons/Help';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import FormatLineSpacingIcon from '@material-ui/icons/FormatLineSpacing';
import {StarBorderOutlined} from "@material-ui/icons";
import UpdateIcon from '@material-ui/icons/Update';
import {MainNavigation} from "@cabinet-packages/components";
import ListOfPromotions from "../pages/ListOfPromotions";
import {
    AddUnregisterPatients,
    AssaySchedulerDay,
    CollectionPoints,
    FeedbackOfAssays,
    HowToPrepare,
    NotificationManager,
    PortmoneFailure,
    PortmoneSuccess,
    RefundPage,
    Support,
} from '@cabinet-packages/pages';
import ActionsDetails from "../pages/ActionsDetails";
import CatalogTable from "../pages/CatalogTable";
import OrderManager from "../pages/OrderManager";
import ConfirmOrder from "../pages/ConfirmOrder";
import AssaySchedulerTime from "@cabinet-packages/components/scduler/AssaySchedulerTime";
import AssayInfo from "../pages/AssayInfo";
import OrderCollectionPoints from "../pages/OrderCollectionPoints";
import AuthPage from "../pages/AuthPage";
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import CabinetPatientCard from "../pages/CabinetPatientCard";
import CabinetAddNewPatient from "../pages/CabinetAddNewPatient";
import CabinetPatientResults from "../pages/CabinetPatientResults";
import CabinetSupport from "../pages/СabinetSupport";
import MobileAccountSettings from "../pages/MobileAccountSettings";
import CabinetPatientAssaysHistoryWrapper from "../pages/CabinetPatientAssaysHistoryWrapper";
import CabinetOrderHistoryWrapper from "../pages/CabinetOrdersHistoryWrapper";
import ComplexResearch from "../pages/ComplexResearch";
import ComplexInfo from "../pages/ComplexInfo";

const routes = [
    {
        path: '/patient-results',
        component: () => <CabinetPatientResults/>,
        label: 'Результати пацієнта',
        showInNavigation: true,
        underAuth : true,
        icon: <LocalHospitalIcon color="primary" fontSize="inherit"/>,
    },
    {
        path: '/add-unregister-patient',
        component: () => <AddUnregisterPatients/>,
        underAuth : true,
        label: 'Неактивні пацієнти',
        showInNavigation: false,
        icon: <AccountTreeIcon color="primary" fontSize="inherit"/>,
    },
    {
        path: '/patient-assays-history',
        component: () => <CabinetPatientAssaysHistoryWrapper/>,
        label: 'Історія досліджень',
        underAuth : true,
        showInNavigation: true,
        icon: <HistoryIcon color="primary" fontSize="inherit"/>,
    },
    {
        path: '/assay-scheduler-time',
        component: () => <AssaySchedulerTime/>,
        label: 'Вибір часу',
        showInNavigation: false,
        underAuth : true,
    },
    {
        path: '/patient-orders-history',
        component: () => <CabinetOrderHistoryWrapper/>,
        label: 'Замовлені дослідження',
        underAuth : true,
        showInNavigation: true,
        icon: <UpdateIcon color="primary" fontSize="inherit"/>,
    },
    {
        path: '/catalog-table',
        component: () => <CatalogTable/>,
        label: 'Дослідження',
        underAuth : true,
        showInNavigation: true,
        icon: <PlaylistAddIcon color="primary" fontSize="inherit"/>,
    },
    {
        path: '/comprehensive-research',
        underAuth : true,
        component: () => <ComplexResearch/>,
        label: 'Комплексні дослідження',
        showInNavigation: true,
        icon: <FormatLineSpacingIcon color="primary" fontSize="inherit"/>,
    },
    {
        path: '/collection-points',
        component: () => <CollectionPoints/>,
        label: 'Пункти забору',
        showInNavigation: true,
        underAuth : true,
        icon: <LocationOnIcon color="primary" fontSize="inherit"/>,
    },
    {
        path: '/patient-actions',
        component: () => <ListOfPromotions/>,
        label: 'Акції',
        underAuth : true,
        showInNavigation: true,
        icon: <CardGiftCardIcon color="primary" fontSize="inherit"/>,
    },
    {
        path: '/how-to-prepare',
        component: () => <HowToPrepare/>,
        label: 'Як підготуватись?',
        underAuth : true,
        showInNavigation: false,
    },
    {
        path: '/support',
        component: () => <Support/>,
        label: 'Підтримка',
        underAuth : true,
        showInNavigation: false,
        icon: <HelpIcon color="primary" fontSize="inherit"/>,
    },
    {
        path: '/feedback-of-assays',
        underAuth : true,
        component: () => <FeedbackOfAssays/>,
        label: 'Ваші відгуки',
        showInNavigation: false,
        icon: <StarBorderOutlined color="primary" fontSize="inherit"/>,
    },
    {
        path: '/main-navigation',
        component: () => <MainNavigation/>,
        label: 'Головне меню',
        showInNavigation: false,
        underAuth : true,
    },
    {
        path: '/actions-details/:id',
        component: () => <ActionsDetails/>,
        label: 'Деталі акції',
        underAuth : true,
        showInNavigation: false,
    },
    {
        path: '/patient-card',
        component: () => <CabinetPatientCard/>,
        underAuth : true,
        label: 'Карта пацієнта',
        showInNavigation: false,
    },
    {
        path: '/account-settings',
        component: () => <MobileAccountSettings/>,
        underAuth : true,
        label: 'Персональні налаштування',
        showInNavigation: false,
    },
    {
        path: '/add-new-patient',
        component: () => <CabinetAddNewPatient/>,
        underAuth : true,
        label: 'Додавання нового пацієнта',
        showInNavigation: false,
    },
    {
        path: '/notification-manager',
        component: () => <NotificationManager/>,
        label: 'Сповіщення',
        underAuth : true,
        showInNavigation: false,
    },
    {
        path: '/assay-info/:id',
        component: () => <AssayInfo/>,
        underAuth : true,
        label: 'Інформація про дослідження',
        showInNavigation: false,
    },
    {
        path: '/complex-info/:id',
        component: () => <ComplexInfo/>,
        underAuth : true,
        label: 'Інформація про комплекс',
        showInNavigation: false,
    },
    {
        path: '/order-manager',
        underAuth : true,
        component: () => <OrderManager/>,
        label: 'Керування замовленнями',
        showInNavigation: false,
    },
    {
        path: '/order-collection-points',
        underAuth : true,
        component: () => <OrderCollectionPoints/>,
        label: 'Вибір пункту забору',
        showInNavigation: false,
    },
    {
        path: '/assay-scheduler-day',
        underAuth : true,
        component: () => <AssaySchedulerDay/>,
        label: 'Вибір часу',
        showInNavigation: false,
    },
    {
        path: '/confirm-order',
        underAuth : true,
        component: () => <ConfirmOrder/>,
        label: 'Перевірте правильність даних',
        showInNavigation: false,
    },
    {
        path: '/portmone-payment',
        underAuth : true,
        component: () => <p>Дякуємо за замовлення!</p>,//<PortmonePaymentPage/>,
        label: 'Оплата замовлення',
        showInNavigation: false,
    },
    {
        path: '/portmone-failure',
        component: () => <PortmoneFailure/>,
        underAuth : false,
        hasOwnPage : true,
        showInNavigation: false,
    },
    {
        path: '/portmone-success',
        component: () => <PortmoneSuccess/>,
        underAuth : false,
        hasOwnPage : true,
        showInNavigation: false,
    },
    {
        path: '/refund',
        component: () => <RefundPage/>,
        label: 'Скасування замовлення',
        showInNavigation: false,
        underAuth : true,
    },
    {
        path: '/auth',
        component: () => <AuthPage/>,
        underAuth : false,
        hasOwnPage : true,
        showInNavigation: false,
    },
    {
        path: '/info/support',
        component: () => <CabinetSupport/>,
        label: 'Підтримка',
        underAuth : true,
        showInNavigation: true,
        icon: <HelpIcon color="primary" fontSize="inherit"/>,
    },
];

export default routes;
